<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row w-100 mx-0 my-0 row-style">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img [src]="'assets/images/alert.png'" [srcset]="'assets/images/alert@2x.png 2x, assets/images/alert@3x.png 3x'">
    </div>
    <div class="col-12 d-flex justify-content-center">
      <label
        class="warning-title">{{this.textService.keyValueMapping('accountSuspendPopupHeader', 'Uyarı', sdkInitTexts)}}</label>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <label
        class="warning-body">{{this.textService.keyValueMapping('accountSuspendPopupText', 'Güvenliğiniz için hesabınız dondurulmuştur.', sdkInitTexts)}}
        <br>
        {{this.textService.keyValueMapping('accountSuspendPopupDescription', 'Şifre yenile butonuna basarak yeni şifre', sdkInitTexts)}}
        <br>
        {{this.textService.keyValueMapping('accountSuspendPopupDescriptionContinue', 'belirleyebilirsiniz.', sdkInitTexts)}}
        <br>
        {{this.textService.keyValueMapping('accountSuspendPopupSubDescription', 'Detaylı bilgi: 0850 622 6060', sdkInitTexts)}}
      </label>
    </div>
    <div class="col-12 d-flex justify-content-center button-groups">
      <div>
        <button class="cancel" (click)="close()"><span
          class="text-style">{{this.textService.keyValueMapping('accountSuspendPopupCancelButton', 'İptal Et', sdkInitTexts)}}</span>
        </button>
      </div>
      <div style="margin-left: 11px">
        <button class="update" (click)="onClick()"><span
          class="text-style-update">{{this.textService.keyValueMapping('accountSuspendPopupResetButton', 'Şifre Yenile', sdkInitTexts)}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
